import React, { useMemo } from 'react';
import SourceSelector from '@/components/SourceSelector';
import type { Source } from '@/types';

export default function SourceFieldset({
  sources,
  selected,
  onToggle,
  onSetSelected,
  emptyHint,
}: {
  sources: Source[];
  selected: string[];
  onToggle: (name: string) => void;
  onSetSelected?: (names: string[]) => void;
  emptyHint?: string;
}) {
  const enabledNames = useMemo(
    () => sources.filter((s) => s.is_enabled).map((s) => s.name),
    [sources],
  );

  const groupByCategory = sources.some((s, _, arr) =>
    arr.some((o) => o.category !== s.category),
  );

  return (
    <SourceSelector
      sources={sources}
      selected={selected}
      onToggle={onToggle}
      onSelectAll={onSetSelected ? () => onSetSelected(enabledNames) : undefined}
      onClearAll={onSetSelected ? () => onSetSelected([]) : undefined}
      emptyHint={emptyHint}
      legend="Sources to monitor"
      groupByCategory={groupByCategory}
    />
  );
}
